import { AlertsProcessProps } from './props';
import { useAlertsProcess } from './hook';
import Loading from '../../../../../components/general/loadings/loading';
import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const AlertsProcess = ({ alert, loading }: AlertsProcessProps) => {
    const { formik } = useAlertsProcess(alert);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Estados
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Estado"
                    name="status"
                    size="small"
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChange={console.log}
                />
            </Grid>
            {formik.values.newStatus && (
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Nuevo Estado"
                        name="newStatus"
                        size="small"
                        errors={formik.errors.newStatus}
                        value={formik.values.newStatus as string}
                    />
                </Grid>
            )}
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Proceso
                </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionChannel}
                    errors={formik.errors.receptionChannel}
                    value={formik.values.receptionChannel as string}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Tipo PQR"
                    name="typePQR"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typePQR}
                    errors={formik.errors.typePQR}
                    value={formik.values.typePQR as string}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Medio"
                    name="receivedThrough"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receivedThrough}
                    errors={formik.errors.receivedThrough}
                    value={formik.values.receivedThrough as string}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Subtipo DP"
                    name="subtypeDP"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.subtypeDP}
                    errors={formik.errors.subtypeDP}
                    value={formik.values.subtypeDP as string}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Tramite"
                    name="transaction"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.transaction}
                    errors={formik.errors.transaction}
                    value={formik.values.transaction as string}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Detalles
                </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    disabled
                    errors={formik.errors.name}
                    value={formik.values.name as string}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Observación"
                    name="observation"
                    size="small"
                    rows={2}
                    errors={formik.errors.observation}
                    value={formik.values.observation as string}
                />
            </Grid>
        </Grid>
    );
};
